var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionCost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0C7.76019 0.00298535 9.99701 2.23981 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5ZM6.57792 7.20125C6.74893 7.35307 7.00961 7.34164 7.16667 7.17542V7.17583C7.24125 7.09411 7.28026 6.98607 7.2751 6.87555C7.26994 6.76503 7.22104 6.66109 7.13917 6.58667L5.20833 4.81667V2.70833C5.20833 2.47821 5.02179 2.29167 4.79167 2.29167C4.56155 2.29167 4.375 2.47821 4.375 2.70833V5C4.37542 5.11701 4.42501 5.22845 4.51167 5.30708L6.57792 7.20125Z",
    fill: "#1E2734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionCost);
export default __webpack_public_path__ + "static/media/action-cost.d002fd2bacb196516b700a79ee60d081.svg";
export { ForwardRef as ReactComponent };